import { render, staticRenderFns } from "./shopSupport.vue?vue&type=template&id=4d5c348e&scoped=true"
import script from "./shopSupport.vue?vue&type=script&lang=js"
export * from "./shopSupport.vue?vue&type=script&lang=js"
import style0 from "./shopSupport.vue?vue&type=style&index=0&id=4d5c348e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c348e",
  null
  
)

export default component.exports